import { render, staticRenderFns } from "./PlanAdmin.vue?vue&type=template&id=5906814c"
import script from "./PlanAdmin.vue?vue&type=script&lang=js"
export * from "./PlanAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports